/* ============================================================
   DAILY CHARGE — Theme JavaScript
   Cart Drawer | Accordion | Mobile Nav | Toast | ATC
   ============================================================ */

(function() {
  'use strict';

  // ── Cart State ──────────────────────────────────────────
  let cartData = null;

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cartData = await res.json();
    return cartData;
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    cartData = await res.json();
    return cartData;
  }

  // ── Cart Count ──────────────────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    document.querySelectorAll('.cart-drawer-count').forEach(el => {
      el.textContent = `(${count})`;
    });
  }

  // ── Cart Drawer ─────────────────────────────────────────
  const cartDrawer = document.querySelector('.cart-drawer');
  const overlay = document.getElementById('overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  overlay && overlay.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('.cart-drawer-close').forEach(btn => {
    btn.addEventListener('click', closeCartDrawer);
  });

  document.querySelectorAll('.header-cart-btn').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer() {
    fetchCart().then(cart => {
      updateCartCount(cart.item_count);
      const itemsContainer = document.querySelector('.cart-drawer-items');
      const subtotalEl = document.querySelector('.cart-subtotal span:last-child');
      if (!itemsContainer) return;

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="cart-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <p>Your cart is empty</p>
            <a href="/collections/all" class="btn btn--outline mt-4" style="margin-top:16px">Shop Now</a>
          </div>`;
        if (subtotalEl) subtotalEl.textContent = '$0.00';
        return;
      }

      itemsContainer.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="cart-item-info">
            <div class="cart-item-topline">
              <div class="cart-item-title">${item.product_title}</div>
              <button type="button" class="cart-item-remove" data-key="${item.key}" aria-label="Remove ${item.product_title} from cart">×</button>
            </div>
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item-qty" aria-label="Quantity controls">
              <button type="button" class="qty-btn qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button type="button" class="qty-btn qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>`).join('');

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      // Qty buttons
      itemsContainer.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.key;
          const qty = parseInt(btn.dataset.qty);
          btn.disabled = true;
          await updateCartItem(key, qty);
          renderCartDrawer();
        });
      });

      itemsContainer.querySelectorAll('.cart-item-remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          await updateCartItem(btn.dataset.key, 0);
          renderCartDrawer();
        });
      });
    });
  }

  // ── Add to Cart Buttons ─────────────────────────────────
  document.querySelectorAll('[data-atc], .product-card-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      const variantId = btn.dataset.atc || btn.dataset.variantId;
      if (!variantId) {
        console.error('Daily Charge: product card is missing a Shopify variant ID.');
        return;
      }

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        await addToCart(variantId, 1);
        btn.textContent = 'Added!';
        showToast('Added to cart!', 'success');
        await fetchCart();
        updateCartCount(cartData.item_count);
        openCartDrawer();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      } catch (e) {
        console.error('Daily Charge: add-to-cart error', e);
        btn.textContent = 'Error — Try Again';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      }
    });
  });

  // ── Product Page ATC ────────────────────────────────────
  const productAtcBtn = document.querySelector('.product-atc-btn');
  if (productAtcBtn) {
    productAtcBtn.addEventListener('click', async () => {
      const variantId = productAtcBtn.dataset.variantId;
      if (!variantId) return;
      const originalText = productAtcBtn.innerHTML;
      productAtcBtn.disabled = true;
      productAtcBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="spin"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Adding...';
      try {
        await addToCart(variantId);
        productAtcBtn.innerHTML = '✓ Added to Cart!';
        showToast('Added to cart!', 'success');
        openCartDrawer();
        setTimeout(() => {
          productAtcBtn.innerHTML = originalText;
          productAtcBtn.disabled = false;
        }, 2000);
      } catch (e) {
        productAtcBtn.innerHTML = 'Error — Try Again';
        productAtcBtn.disabled = false;
      }
    });
  }

  // ── Accordion ───────────────────────────────────────────
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.accordion-trigger').forEach(t => {
        t.classList.remove('is-open');
        t.nextElementSibling && t.nextElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        trigger.classList.add('is-open');
        content && content.classList.add('is-open');
      }
    });
  });

  // ── Mobile Nav ──────────────────────────────────────────
  const mobileNav = document.querySelector('.mobile-nav');
  const menuBtn = document.querySelector('.header-menu-btn');
  const mobileClose = document.querySelector('.mobile-nav-close');

  menuBtn && menuBtn.addEventListener('click', () => {
    mobileNav && mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  mobileClose && mobileClose.addEventListener('click', () => {
    mobileNav && mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  // ── Toast ───────────────────────────────────────────────
  function showToast(message, type = '') {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.className = `toast${type ? ' toast--' + type : ''}`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('is-visible'));
    });
    setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  // ── Reviews Carousel Scroll ─────────────────────────────
  function initCarousels() {
    document.querySelectorAll('.reviews-carousel-wrapper').forEach(wrapper => {
      if (wrapper.dataset.carouselInit) return;
      wrapper.dataset.carouselInit = 'true';
      const carousel = wrapper.querySelector('.reviews-carousel');
      const leftBtn = wrapper.querySelector('.reviews-scroll-left');
      const rightBtn = wrapper.querySelector('.reviews-scroll-right');
      if (!carousel) return;
      var scrollAmount = 360;
      if (leftBtn) {
        leftBtn.addEventListener('click', function() {
          carousel.scrollLeft = carousel.scrollLeft - scrollAmount;
        });
      }
      if (rightBtn) {
        rightBtn.addEventListener('click', function() {
          carousel.scrollLeft = carousel.scrollLeft + scrollAmount;
        });
      }
    });
  }
  initCarousels();
  // Re-init if Shopify loads sections dynamically
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function() { initCarousels(); }).observe(document.body, { childList: true, subtree: true });
  }

  // ── Init cart count ─────────────────────────────────────
  fetchCart().then(cart => updateCartCount(cart.item_count));

  // ── Sticky header shadow ────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.4)' : '';
    }, { passive: true });
  }

})();
